/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
// document.addEventListener('click', function(e) {
//   const btn = e.target.closest('[data-action="toggle-collapsible"]');
//   if (!btn) return;
//   // only run below 999px
//   if (window.innerWidth > 999) return;
//   btn.classList.toggle('active');
// });

// document.addEventListener('click', function (e) {
//   const btn = e.target.closest('[data-action="toggle-collapsible"]');
//   if (!btn) return;
//   const id = btn.getAttribute('aria-controls');
//   const content = document.getElementById(id);
//   const isOpen = btn.getAttribute('aria-expanded') === 'true';
//   btn.setAttribute('aria-expanded', !isOpen);
//   content.setAttribute('aria-hidden', isOpen);
//   if (!isOpen) {
//     content.style.height = content.scrollHeight + "px";
//   } else {
//     content.style.height = "0px";
//   }
// });

// document.querySelectorAll('[data-action="toggle-collapsible"]').forEach(button => {
//   button.addEventListener('click', () => {
    
//     const content = document.getElementById(button.getAttribute('aria-controls'));

//     const isOpen = button.getAttribute('aria-expanded') === 'true';

//     // Toggle
//     button.setAttribute('aria-expanded', !isOpen);
//     content.classList.toggle('is-open', !isOpen);
//     content.setAttribute('aria-hidden', isOpen);
//   });
// });


document.querySelectorAll('[data-action="toggle-collapsible"]').forEach(button => {
  button.addEventListener('click', () => {
    
    const content = document.getElementById(button.getAttribute('aria-controls'));

    const isOpen = button.getAttribute('aria-expanded') === 'true';

    // Toggle
    button.setAttribute('aria-expanded', !isOpen);
    content.classList.toggle('is-open', !isOpen);
    content.setAttribute('aria-hidden', isOpen);
  });
});


